export default {
    init() {
        setupBlocks();
    }
}

function setupBlocks() {
    let $blocks = $('.block-resources-cards').not('.initialised');

    if ($blocks.length > 0) {
        $blocks.each((index, item) => {
            let $block = $(item);

            setupBlock($block);

            $block.addClass('initialised');
        });
    }
}

function setupBlock($block) {
    let $resourcesCardsCarousel = $block.find('.resources-cards-carousel');

    $resourcesCardsCarousel.slick({
            variableWidth: true,
            centerMode: false,
            arrows: true,
            infinite: false,
            prevArrow: '<button type="button"><div class="arrow-wrap left"><span class="arrow-icon"></span></div></button>',
            nextArrow: '<button type="button"><div class="arrow-wrap right"><span class="arrow-icon"></span></div></button>',

            responsive: [
                {
                    breakpoint: 1920,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1,
                        variableWidth: true,
                        centerMode: false,
                        infinite: true
                    }
                },
                {
                    breakpoint: 1500,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                        variableWidth: true,
                        centerMode: false,
                        infinite: true
                    }
                },
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        variableWidth: true,
                        infinite: true
                    }
                },
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ]
        }
    );
}